import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnChannel } from '@lib/communication/twiliochat';

@Component({
  selector: 'sn-text-message',
  templateUrl: './text-message.component.html',
  styleUrls: ['./text-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.system]': 'isSystemMessage',
  },
})
export class SnTextMessageComponent {
  @Input() public text: string;
  @Input() public isEdited = false;
  @Input() public isSystemMessage = false;
  public channel: SnChannel;

  constructor() {}
}
